<div class="article-page" *ngIf="data">
    <div class="container">
        <div class="article-page--header">
            {{data.headline}}
        </div>
        <div class="article-page--headline"></div>
        <div *ngIf="!voiceUrl" [attr.tabindex]="0" role="button" [attr.aria-label]="'Listen to the report' | translate"
            class="article-page--audio" (click)="getSpeech()" (keyup.enter)="getSpeech()">
            <div class="audio-block">
                <i class="fas fa-play"></i>
            </div>
            <div>{{ 'Listen to the report' | translate }}</div>
        </div>
        <div *ngIf="voiceUrl" class="article-page--audio">
            <audio #audioOption controls>
                <source src="{{voiceUrl}}" type="audio/mpeg">
                {{ 'Your browser does not support the audio element.' | translate }}
            </audio>
        </div>
        <div class="article-page--body">
            <div [innerHTML]="data.content | storyblokRichtext"></div>
        </div>
        <div class="article-page--btn">
            <button class="btn btn--secondary" (click)="back()">
                {{'Back' | translate}}
            </button>
        </div>
    </div>
</div>